// South African Public Holidays
// Returns public holidays for a given year

export function getSAPublicHolidays(year) {
  const holidays = [
    { name: "New Year's Day", date: `${year}-01-01` },
    { name: "Human Rights Day", date: `${year}-03-21` },
    { name: "Good Friday", date: getGoodFriday(year) },
    { name: "Family Day", date: getFamilyDay(year) },
    { name: "Freedom Day", date: `${year}-04-27` },
    { name: "Workers' Day", date: `${year}-05-01` },
    { name: "Youth Day", date: `${year}-06-16` },
    { name: "National Women's Day", date: `${year}-08-09` },
    { name: "Heritage Day", date: `${year}-09-24` },
    { name: "Day of Reconciliation", date: `${year}-12-16` },
    { name: "Christmas Day", date: `${year}-12-25` },
    { name: "Day of Goodwill", date: `${year}-12-26` },
  ];

  // Add observed holidays when they fall on Sunday
  const observedHolidays = [];
  holidays.forEach(holiday => {
    const date = new Date(holiday.date);
    if (date.getDay() === 0) { // Sunday
      const observedDate = new Date(date);
      observedDate.setDate(observedDate.getDate() + 1); // Monday
      observedHolidays.push({
        name: `${holiday.name} (Observed)`,
        date: observedDate.toISOString().split('T')[0],
        isObserved: true
      });
    }
  });

  return [...holidays, ...observedHolidays].sort((a, b) => 
    a.date.localeCompare(b.date)
  );
}

// Calculate Good Friday (Easter Sunday - 2 days)
function getGoodFriday(year) {
  const easter = getEasterSunday(year);
  easter.setDate(easter.getDate() - 2);
  return easter.toISOString().split('T')[0];
}

// Calculate Family Day (Easter Monday)
function getFamilyDay(year) {
  const easter = getEasterSunday(year);
  easter.setDate(easter.getDate() + 1);
  return easter.toISOString().split('T')[0];
}

// Calculate Easter Sunday using Computus algorithm
function getEasterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  
  return new Date(year, month - 1, day);
}

// Check if a date is a public holiday
export function isPublicHoliday(dateString, year) {
  const holidays = getSAPublicHolidays(year);
  return holidays.some(h => h.date === dateString);
}

// Get holiday name for a specific date
export function getHolidayName(dateString, year) {
  const holidays = getSAPublicHolidays(year);
  const holiday = holidays.find(h => h.date === dateString);
  return holiday ? holiday.name : null;
}
